import { Reducer } from "redux";

import { DisciplineRequestorActionDispatchTypes } from "../constants/Master";
import { DisciplineRequestorResponse } from "../models/Api/Master";
import { DisciplineRequestorDispatchTypes } from "../models/DispatchTypes/Master";

export const initialPostState: DisciplineRequestorResponse = {
  loading: false,
  response: [],
};

const DisciplineRequestorReducer: Reducer<
  DisciplineRequestorResponse,
  DisciplineRequestorDispatchTypes
> = (state = initialPostState, action) => {
  switch (action.type) {
    case DisciplineRequestorActionDispatchTypes.DISCIPLINE_REQUESTOR_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DisciplineRequestorActionDispatchTypes.DISCIPLINE_REQUESTOR_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DisciplineRequestorActionDispatchTypes.DISCIPLINE_REQUESTOR_ERROR: {
      return initialPostState
    }
  }
  return state;
};

export default DisciplineRequestorReducer;
